const LocalPrice = (e) => {
  if (isNaN(e)) {
    return 0.0;
  } else
    return Number(e).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
};

export default LocalPrice;
